<script setup lang="ts">

import { useIsHostedInBrowser } from "@modules/Jupiter"
import { useNotify } from "@library/Components";
import { usePairingState } from '../Types/UsePairingState';
import { useUserSettings } from "@services/UserSettings";
import { AutoInstalledState } from "@domain/General/Enums/AutoInstalledState";
import type { IMyGarageViewModel } from "@app/MyGarage/Types/IMyGarageViewModel";

type Props = { model: IMyGarageViewModel }
const { model } = defineProps<Props>();
const isOpen = defineModel<boolean>( { required: true } );
const isHostedInBrowser = useIsHostedInBrowser();
const pairing = usePairingState();

async function setHealthMonitorNotInstalled()
{
    await useNotify( "The Health Monitor has been disabled.  You can re-enable it at any time from Settings", "Health Monitor" );
    const settings = useUserSettings();
    pairing.cancelSkip();
    settings.healthMonitorEnabledState = AutoInstalledState.NotInstalled;
    model.carePlan.healthMonitor.updateInstalledState();
    await pairing.endPairing();
}

</script>

<template>

    <div class="fixed bottom-0 left-0 w-full h-[100%] flex flex-col justify-end
                z-50 pointer-events-none 3xl:max-w-xl 3xl:m-auto
                bg-gradient-to-b from-transparent to-black/30 via-30% via-black/30
                translate-y-12 opacity-0 transition-[transform,opacity] duration-300"
         :class="{
            '!opacity-100 !translate-y-0 pointer-events-auto': isOpen
         }"
         @click="() => isOpen = false">

        <div class="rounded-t-xl p-4 3xl:p-6
                    bg-gradient-to-b from-gray-850 to-gray-900"
             :class="{
                 '!pb-12': isHostedInBrowser 
             }">
        
            <div class="flex items-center justify-center pb-2">
                <div class="absolute rounded-full h-1 w-10 bg-white/10"/>
            </div>

            <div class="flex justify-center pt-2 text base lg:text-lg 3xl:text-2xl text-white tracking-wider pb-2">
                Are you sure?
            </div>
        
            <div class="text base lg:text-lg 3xl:text-2xl text-white tracking-wider text-center opacity-60">
                You need to keep the Health Monitor connected to protect your car
            </div>


            <div class="flex flex-col gap-2 mt-4">
            
                <JupiterButton type="page"
                               color="secondary"
                               class="!h-12 3xl:!h-14"
                               to="vehiclesettings"
                               variant="flat"
                               @click="() => pairing.beginPairing()">
                    Connect Health Monitor
                </JupiterButton> 

                <Button variant="tonal"
                        class="!h-12 3xl:!h-14"
                        @click="() => pairing.skipPairing()">
                    Skip for now
                </Button>   
                
                <Button variant="tonal"
                        class="!h-12 3xl:!h-14"
                        @click="() => setHealthMonitorNotInstalled()">
                    I don't have a Health Monitor
                </Button>   

            </div>

        </div>

    </div>

</template>